import EventEmitter from 'events'
import {EXPIRED_TOKEN_TIME, GLOT_SECRET_COOKIE} from '@/config/commonConfig'
import VueCookies from 'vue-cookies'
import auth from '@/http/requests/auth/webAuth'
import store from '@/store/store.js'

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const localStorageKey = 'loggedIn'

const tokenExpiryKey = 'tokenExpiry'
const loginEvent = 'loginEvent'

class AuthService extends EventEmitter {

  // Handles the callback request from Auth0
  handleAuthentication (fullPath, name) {
    return new Promise((resolve, reject) => {
      auth.validateCallBack(fullPath).then(res => {

        let loginType = 'facebook'
        if (name === 'callback-facebook') {
          loginType = 'facebook'
        }
        if (name === 'callback-google') {
          loginType = 'google'
        }
        if (name === 'callback-apple') {
          loginType = 'apple'
        }
        this.localLogin(res.data, loginType)
        resolve(res.data.jwt)
      }).catch(err => {
        reject(err)
      })
    })
  }

  localLogin (authResult, loginType) {
    console.log(authResult, 'authResult')
    localStorage.setItem('accessToken', authResult.jwt)

    store.commit('UPDATE_LAST_USER', {
      name: authResult.user.email,
      type: loginType
    })

    // Convert the JWT expiry time from seconds to milliseconds
    // eslint-disable-next-line no-mixed-operators
    this.tokenExpiry = new Date(Date.now() + EXPIRED_TOKEN_TIME * 24 * 60 * 60 * 1000)
    VueCookies.set(GLOT_SECRET_COOKIE, authResult.jwt, EXPIRED_TOKEN_TIME * 24 * 60 * 60, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
    localStorage.setItem(tokenExpiryKey, this.tokenExpiry)
    localStorage.setItem(localStorageKey, 'true')

    store.commit('UPDATE_USER_INFO', {
      ...authResult.user
    })

    this.emit(loginEvent, {
      loggedIn: true,
      profile: authResult.idTokenPayload,
      state: authResult.appState || {},
      token: authResult.jwt
    })
  }

  logOut () {
    localStorage.removeItem(localStorageKey)
    localStorage.removeItem(tokenExpiryKey)
    localStorage.removeItem('userInfo')
    VueCookies.remove(GLOT_SECRET_COOKIE, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
    VueCookies.remove(GLOT_SECRET_COOKIE)
    this.emit(loginEvent, { loggedIn: false })
  }

  isAuthenticated () {
    if (!VueCookies.get(GLOT_SECRET_COOKIE)) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem(localStorageKey)
      localStorage.removeItem(tokenExpiryKey)
    }
    return (
      new Date(Date.now()) < new Date(localStorage.getItem(tokenExpiryKey)) &&
            localStorage.getItem(localStorageKey) === 'true'
    )
  }

  isTokenStillValid () {
    if (!VueCookies.get(GLOT_SECRET_COOKIE)) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem(localStorageKey)
      localStorage.removeItem(tokenExpiryKey)
    }
    return (
      new Date(Date.now()) < new Date(localStorage.getItem(tokenExpiryKey))
    )
  }
}

export default new AuthService()
